export default __webpack_public_path__ + "static/media/route-voucher.b3d4d395.jpg";